import { useAuth } from '@/lib/utils/providers/supabase/supabase-auth-provider'
import {
  NotificationBell,
  NovuProvider,
  PopoverNotificationCenter,
} from '@novu/notification-center'
import { useRouter } from 'next/navigation'
import { IconBase } from 'react-icons/lib'
import { SvgAddPlus } from '../icons'

const NovuCenterDashboard = () => {
  // const { width } = useWindowDimensions()

  const { user } = useAuth()
  const router = useRouter()
  const theme = {
    light: {
      loaderColor: '#2563eb',
    },
    common: {},
  }

  function onNotificationClick(message) {
    if (message?.templateIdentifier === 'invite-team') {
      router.push('/i/profile')
    } else if (
      message?.templateIdentifier === 'account-activation' ||
      message?.templateIdentifier === 'email-accepted' ||
      message?.templateIdentifier === 'email-flow'
    ) {
      router.push(`/i/applications/${message?.payload?.applicationID}`)
    }
  }

  return (
    <NovuProvider
      subscriberId={user?.id}
      applicationIdentifier={
        process.env.NEXT_PUBLIC_NOVU_APP_Application_Identifier
      }
    >
      <PopoverNotificationCenter
        colorScheme={'light'}
        theme={theme}
        onNotificationClick={onNotificationClick}
      >
        {({ unseenCount }) => {
          return (
            <div
              unseenCount={unseenCount}
              className="novu-dash text-white max-w-[28px] h-w-[28px] overflow-hidden cursor-pointer"
            >
              <div className="relative">
                {/* <SvgAddPlus
                  unseenCount={unseenCount}
                  colorScheme="light"
                  unseenBadgeBackgroundColor="red"
                  unseenBadgeColor="blue"
                  
                /> */}
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  color={'#828299'}
                >
                  <path
                    d="M21.6667 10.8C21.6667 8.99653 20.9643 7.26692 19.714 5.99167C18.4638 4.71643 16.7681 4 15 4C13.2319 4 11.5362 4.71643 10.286 5.99167C9.03571 7.26692 8.33333 8.99653 8.33333 10.8C8.33333 18.7333 5 21 5 21H25C25 21 21.6667 18.7333 21.6667 10.8Z"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M17.7295 24C17.4521 24.6072 17.0539 25.1113 16.5748 25.4617C16.0956 25.812 15.5524 25.9965 14.9995 25.9965C14.4466 25.9965 13.9034 25.812 13.4243 25.4617C12.9452 25.1113 12.547 24.6072 12.2695 24"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>

                {unseenCount && unseenCount > 0 ? (
                  <div className="absolute top-0 right-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      class="nc-bell-button-dot css-0 css-1eg2znq"
                      colors="[object Object]"
                    >
                      <rect
                        x="1.5"
                        y="1.5"
                        width="13"
                        height="13"
                        rx="6.5"
                        fill="url(#paint0_linear_1722_2699)"
                        stroke="#FFFFFF"
                        stroke-width="3"
                      ></rect>
                      <defs>
                        <linearGradient
                          id="paint0_linear_1722_2699"
                          x1="8"
                          y1="13"
                          x2="8"
                          y2="3"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stop-color="#FF512F"></stop>
                          <stop offset="1" stop-color="#DD2476"></stop>
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                ) : (
                  ''
                )}
              </div>
              {/* <NotificationBell unseenCount={unseenCount} /> */}
              {/* pl */}
            </div>
            // <div className="text-white">ok</div>
          )
        }}
      </PopoverNotificationCenter>
    </NovuProvider>
  )
}
export default NovuCenterDashboard
